/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentStatus {
    SIGNED = 'Signed',
    SIGNED_NO_MERGE = 'SignedNoMerge',
    PRE_SIGN = 'PreSign',
}
